import { render } from "./AuthenticationCardLogo.vue?vue&type=template&id=27d6e19d&scoped=true"
import script from "./AuthenticationCardLogo.vue?vue&type=script&lang=js"
export * from "./AuthenticationCardLogo.vue?vue&type=script&lang=js"

import "./AuthenticationCardLogo.vue?vue&type=style&index=0&id=27d6e19d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d6e19d"]])

export default __exports__